import SPECIAL_CHARACTERS from '@/utils/enum/SPECIAL_CHARACTERS';
import VARIANTS_OF_KEYS from '@/utils/enum/VARIANTS_OF_KEY';
import { filterProps } from '@/utils/functional-component-utils';
import WorkBaseRestrictedTextField from '@/components/global_components/forms/text_fields/WorkBaseRestrictedTextField';

export default function({
  getFormatter,
  setFormatter,
  formatOnFocusOut,
  formatOnFocusIn,
  formatToReadonly
  }, withDecimalPlaces = false
) {
  const DEFAULT_CHAR_WHITELIST = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  const DEFAULT_ALWAYS_ALLOWED = [
    VARIANTS_OF_KEYS.ARROWLEFT.ALPHABETICAL.join(),
    VARIANTS_OF_KEYS.ARROWRIGHT.ALPHABETICAL.join(),
    VARIANTS_OF_KEYS.DELETE.ALPHABETICAL.join(),
    VARIANTS_OF_KEYS.BACKSPACE.ALPHABETICAL.join(),
    VARIANTS_OF_KEYS.TAB.ALPHABETICAL.join(),
    VARIANTS_OF_KEYS.CONTROL.ALPHABETICAL.join(), 
    VARIANTS_OF_KEYS.V.ALPHABETICAL.join(),
    VARIANTS_OF_KEYS.C.ALPHABETICAL.join()
  ];

  return {
    props: {
      ...filterProps(WorkBaseRestrictedTextField.props, [
        'placeholder',
        'charWhiteList',
        'alwaysAllowedKeys'
      ]),
      charWhitelist: { type: Array, required: false },
      alwaysAllowedKeys: { type: Array, required: false },
      placeholder: { type: String, required: false },
      // flags
      withNegatives: { type: Boolean, default: true }
    },
    computed: {
      internalCharWhiteList() {
        if (this.charWhitelist !== undefined) { return this.charWhitelist; } // prop

        const charWhiteList = DEFAULT_CHAR_WHITELIST;
        if (withDecimalPlaces) {
          charWhiteList.push(SPECIAL_CHARACTERS.COMMA, SPECIAL_CHARACTERS.POINT);
        }

        if (this.withNegatives) {
          charWhiteList.push(SPECIAL_CHARACTERS.MINUS)
        }

        return charWhiteList;
      },
      internalAlwaysAllowedKeys() {
        if (this.alwaysAllowedKeys !== undefined) { 
          return this.alwaysAllowedKeys; 
        }
        return DEFAULT_ALWAYS_ALLOWED;
      },
    },
    methods: {
      invokeGetFormatter(v) {
        if (getFormatter == undefined) { return v }
        return getFormatter(v, this)
      },
      invokeSetFormatter(v) {
        if (setFormatter == undefined) { return v }
        return setFormatter(v, this)
      },
      invokeFormatOnFocusOut(v) {
        if (formatOnFocusOut == undefined) { return this.invokeGetFormatter(v) }
        return formatOnFocusOut(v, this)
      },
      invokeFormatOnFocusIn(v) {
        if (formatOnFocusIn == undefined) { return this.invokeGetFormatter(v) }
        return formatOnFocusIn(v, this)
      },
      invokeReadonlyFormat(v) {
        if (formatToReadonly == undefined) { return this.invokeGetFormatter(v) }
        return formatToReadonly(v, this)
      },
    }
  }
}
